// Thin stacked bar; each segment is a share of the whole in percent.
export default function Meter({ segments, className = "" }) {
  return (
    <div className={`flex h-2 overflow-hidden rounded-full bg-slate-200 ${className}`}>
      {segments.map(({ percent, color }) => (
        <i key={color} className="block h-full" style={{ width: `${percent}%`, backgroundColor: color }} />
      ))}
    </div>
  );
}

export const percentOf = (value, total) => (total > 0 ? (value / total) * 100 : 0);
